import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { devolverOrdenCompleta } from '../../../../actions/ordenesDevolucion';

const DevolverOrdenCompletaModal = ({ show, onHide, idOrden, onSuccess }) => {
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);

    const onConfirm = async () => {
        if (!idOrden) {
            onHide();
            return;
        }

        setSaving(true);
        const ok = await dispatch(devolverOrdenCompleta({ id_orden_salida: idOrden }));
        setSaving(false);

        if (!ok) return;

        onHide();
        if (typeof onSuccess === 'function') onSuccess();
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Devolución completa de la orden</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="alert alert-warning m-0">
                    ¿Estás seguro que deseas registrar la devolución completa de esta orden de salida?
                    {' '}Se devolverá al inventario todo lo entregado (productos y paquetes) y se generará
                    una orden de devolución ya completada.
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onHide}
                    disabled={saving}
                >
                    Cerrar
                </button>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={onConfirm}
                    disabled={saving}
                >
                    Devolver orden completa
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default DevolverOrdenCompletaModal;
